"use strict";
//@ts-check
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.humanReadable = void 0;
var elementwise_1 = require("./elementwise");
var js_interface_1 = require("./js-interface");
var dtypes_1 = require("../dtypes");
var round = elementwise_1.ops.round;
function humanReadable(arr) {
    if (arr.shape.length == 0)
        return arr.flat[0].toString();
    var budgets = arr.shape.map(function (_) { return 1; });
    var lBudget = 30;
    for (var i = 0; i < arr.shape.length; i++) {
        var before = budgets[i];
        budgets[i] = Math.min(arr.shape[i], lBudget);
        if (budgets[i] > before)
            lBudget = Math.floor(lBudget / (budgets[i] - before));
    }
    var rBudget = 30;
    for (var i = arr.shape.length - 1; i >= 0; i--) {
        var before = budgets[i];
        budgets[i] = Math.min(arr.shape[i], rBudget);
        if (budgets[i] > before)
            rBudget = Math.floor(rBudget / (budgets[i] - before));
    }
    function simplify(list, depth) {
        if (depth === void 0) { depth = 0; }
        if (depth == arr.shape.length)
            return list;
        if (2 * budgets[depth] >= list.length) {
            return list.map(function (l) { return simplify(l, depth + 1); });
        }
        var left = list.slice(0, budgets[depth]).map(function (l) { return simplify(l, depth + 1); });
        var right = list.slice(-budgets[depth]).map(function (l) { return simplify(l, depth + 1); });
        return __spreadArray(__spreadArray(__spreadArray([], __read(left), false), ['...'], false), __read(right), false);
    }
    var rLimit = arr.shape.length - 1;
    while (rLimit > 0 && arr.shape[rLimit] == 1) {
        rLimit--;
    }
    if ((0, dtypes_1.dtype_is_float)(arr.dtype))
        arr = round(arr, 2);
    var list = (0, js_interface_1.tolist)(arr);
    function str(list, indent, depth) {
        if (indent === void 0) { indent = 0; }
        if (depth === void 0) { depth = 0; }
        if (list == '...' || depth >= arr.shape.length)
            return list;
        if (depth == arr.shape.length - 1)
            return "[".concat(list.join(', '), "]");
        var sep = depth >= rLimit ? ' ' : '\n' + ' '.repeat(indent + 1);
        var out = [];
        for (var i = 0; i < list.length; i++) {
            var s = str(list[i], indent + 1, depth + 1) + ',';
            out.push(i < list.length - 1 ? s : s.slice(0, -1));
        }
        return "[".concat(out.join(sep), "]");
    }
    var prefix = 'np';
    var suffix = ", shape=(".concat(arr.shape, "), dtype=").concat(arr.dtype.name);
    var out = str(simplify(list), 1 + prefix.length);
    function alignColumns(inputString, delimiter) {
        var e_1, _a, e_2, _b;
        if (delimiter === void 0) { delimiter = ','; }
        // Split the input string into rows
        var rows = inputString.split('\n');
        // Initialize an array to store the maximum width of each column
        var columnWidths = Array(rows[0].split(delimiter).length).fill(0);
        try {
            // Find the maximum width for each column
            for (var rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
                var row = rows_1_1.value;
                var columns = row.split(delimiter);
                for (var i = 0; i < columns.length; i++) {
                    columnWidths[i] = Math.max(columnWidths[i], columns[i].trim().length);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // Build the formatted outputs
        var formattedString = '';
        var _loop_1 = function (row) {
            var columns = row.split(delimiter);
            columns = columns.map(function (s, i) { return i == columns.length - 1 ? s : s + delimiter; });
            for (var i = 0; i < columns.length; i++) {
                var column = columns[i].trim();
                formattedString += column.padStart(columnWidths[i] + 1).padEnd(columnWidths[i] + 2); // Add 1 for padding
            }
            formattedString += '\n';
        };
        try {
            for (var rows_2 = __values(rows), rows_2_1 = rows_2.next(); !rows_2_1.done; rows_2_1 = rows_2.next()) {
                var row = rows_2_1.value;
                _loop_1(row);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (rows_2_1 && !rows_2_1.done && (_b = rows_2.return)) _b.call(rows_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return formattedString;
    }
    out = out.replace(/.*?(\n|$)/g, function (match) {
        // Split with a newline every 0 characters, but only after a comma,
        return match.replace(/(.{60,}?,)/g, '$1\n');
    }).replace(/\n+/g, '\n');
    out = alignColumns("".concat(prefix, "(").concat(out)).trim();
    out = "".concat(out).concat(suffix, ")");
    return out;
}
exports.humanReadable = humanReadable;
